import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/teamStyle.js";

import team1 from "assets/img/faces/drSeif.jpeg";
import team2 from "assets/img/faces/Mostafa.png";
import team4 from "assets/img/faces/eman.jpeg";
import team5 from "assets/img/faces/girgies.jpeg";
import team6 from "assets/img/faces/panse.jpeg";
import team7 from "assets/img/faces/pierre.jpeg";
import team8 from "assets/img/faces/baraa.jpeg";
import team9 from "assets/img/faces/micheal.jpeg";




const useStyles = makeStyles(styles);

export default function TeamSection() {
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <h2 className={classes.title}>Finally, this is our team</h2>
      <div>
        <GridContainer>
          
          
          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={team1} alt="..." className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>
              Seif Eldawlatly, Ph.D 
                <br />
                <small className={classes.smallTitle}>Project Supervisor</small>
              </h4>
              <CardBody>
                <p className={classes.description}>
                Associate Professor
                Computer and Systems Engineering Department
                Ain Shams University, Cairo, Egypt
                </p>
              </CardBody>
              <CardFooter className={classes.justifyCenter}>
                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://www.linkedin.com/in/seif-eldawlatly-0433901aa/'
                  target="_blank"
>
                  <i className={classes.socials + " fab fa-linkedin"} />
                </Button>
              </CardFooter>
            </Card>
          </GridItem>


          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={team4} alt="..." className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>
              Eman Mohamed 
                <br />
                <small className={classes.smallTitle}>Student</small>
              </h4>
              <CardBody>
                <p className={classes.description}>
                  <br/>
                Project Member 
                  <br/>
                </p>
              </CardBody>
              <CardFooter className={classes.justifyCenter}>
                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://www.linkedin.com/in/eman-mohamed-03a98a178'
                  target="_blank"

                >
                  <i className={classes.socials + " fab fa-linkedin"} />
                </Button>

                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://github.com/Eman2554'
                  target="_blank"
                >
                  <i className={classes.socials + " fab fa-github"} />
                </Button>
              </CardFooter>
            </Card>
          </GridItem>


          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={team6} alt="..." className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>
              Panse Yasser 
                <br />
                <small className={classes.smallTitle}>Student</small>
              </h4>
              <CardBody>
                <p className={classes.description}>
                  <br/>
                Project Member 
                  <br/>
                </p>
              </CardBody>
              <CardFooter className={classes.justifyCenter}>
                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://www.linkedin.com/in/panse-yasser'
                  target="_blank"

                >
                  <i className={classes.socials + " fab fa-linkedin"} />
                </Button>

                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://github.com/panse98'
                  target="_blank"
                >
                  <i className={classes.socials + " fab fa-github"} />
                </Button>
              </CardFooter>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={team8} alt="..." className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>
              Baraa Magdy
                <br />
                <small className={classes.smallTitle}>Student</small>
              </h4>
              <CardBody>
                <p className={classes.description}>
                  <br/>
                Project Member 
                  <br/>
                </p>
              </CardBody>
              <CardFooter className={classes.justifyCenter}>
                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://www.linkedin.com/in/baraa-magdy-537077151/'
                  target="_blank"

                >
                  <i className={classes.socials + " fab fa-linkedin"} />
                </Button>

                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://github.com/baraamagdy'
                  target="_blank"
                >
                  <i className={classes.socials + " fab fa-github"} />
                </Button>
              </CardFooter>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={team7} alt="..." className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>
              Pierre Nabil  
                <br />
                <small className={classes.smallTitle}>Student</small>
              </h4>
              <CardBody>
                <p className={classes.description}>
                  <br/>
                Project Member 
                  <br/>
                </p>
              </CardBody>
              <CardFooter className={classes.justifyCenter}>
                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://www.linkedin.com/mwlite/in/pierre-nabil-84271a151'
                  target="_blank"

                >
                  <i className={classes.socials + " fab fa-linkedin"} />
                </Button>

                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://github.com/PierreNabil'
                  target="_blank"
                >
                  <i className={classes.socials + " fab fa-github"} />
                </Button>
              </CardFooter>
            </Card>
          </GridItem>


          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={team5} alt="..." className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>
              Girgis Michael 
                <br />
                <small className={classes.smallTitle}>Student</small>
              </h4>
              <CardBody>
                <p className={classes.description}>
                  <br/>
                Project Member 
                  <br/>
                </p>
              </CardBody>
              <CardFooter className={classes.justifyCenter}>
                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href=' https://www.linkedin.com/in/girgis-micheal-0b7699167/'
                  target="_blank"

                >
                  <i className={classes.socials + " fab fa-linkedin"} />
                </Button>

                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://github.com/girgismicheal'
                  target="_blank"
                >
                  <i className={classes.socials + " fab fa-github"} />
                </Button>
              </CardFooter>
            </Card>
          </GridItem>


          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={team9} alt="..." className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>
              Michael Magdy 
                <br />
                <small className={classes.smallTitle}>Student</small>
              </h4>
              <CardBody>
                <p className={classes.description}>
                  <br/>
                Project Member 
                  <br/>
                </p>
              </CardBody>
              <CardFooter className={classes.justifyCenter}>
                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://www.linkedin.com/in/michael-magdy-45a34b206/'
                  target="_blank"

                >
                  <i className={classes.socials + " fab fa-linkedin"} />
                </Button>

                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://github.com/Michael-M-Mike'
                  target="_blank"
                >
                  <i className={classes.socials + " fab fa-github"} />
                </Button>
              </CardFooter>
            </Card>
          </GridItem>


          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={team2} alt="..." className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>
              Mostafa Ashraf 
                <br />
                <small className={classes.smallTitle}>Student</small>
              </h4>
              <CardBody>
                <p className={classes.description}>
                  <br/>
                Project Member 
                  <br/>
                </p>
              </CardBody>
              <CardFooter className={classes.justifyCenter}>
                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://www.linkedin.com/in/mostafa-ashraf-a62807142/'
                  target="_blank"

                >
                  <i className={classes.socials + " fab fa-linkedin"} />
                </Button>

                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                  href='https://github.com/Mostafa-ashraf19'
                  target="_blank"
                >
                  <i className={classes.socials + " fab fa-github"} />
                </Button>
              </CardFooter>
            </Card>
          </GridItem>

          





         


        </GridContainer>
      </div>
    </div>
  );
}
